import React from 'react'
import { Box, Button, Divider, Drawer, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded'
import AppsRoundedIcon from '@mui/icons-material/AppsRounded'
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded'
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded'
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded'
import FactoryRoundedIcon from '@mui/icons-material/FactoryRounded'
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded'
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded'
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded'
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded'
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded'
import SpaRoundedIcon from '@mui/icons-material/SpaRounded'
import { APP_DATA } from '../../data'
import { getQualityCapabilities } from '../../utils/permisos'
import { getSidebarApplications, getSuiteUrl } from '../../utils/navigation'
import LogoSuite from '../../media/CALIDAD_PRODUCCION.png'

const getApplicationIcon = (application) => {
  const key = `${application.icon || ''} ${application.code} ${application.label}`.toLowerCase()
  if (/truck|logistic/.test(key)) return <LocalShippingRoundedIcon />
  if (/citrus|pedido|order/.test(key)) return <ReceiptLongRoundedIcon />
  if (/fact|bill|invoice/.test(key)) return <DescriptionRoundedIcon />
  if (key.includes('entrada')) return <FactCheckRoundedIcon />
  if (/produccion|production/.test(key)) return <FactoryRoundedIcon />
  if (/stock|camara/.test(key)) return <Inventory2RoundedIcon />
  if (/flujo|flow/.test(key)) return <SpaRoundedIcon />
  if (/analisis|analytics/.test(key)) return <AssessmentRoundedIcon />
  if (/campo|quality/.test(key)) return <ShieldRoundedIcon />
  return <AppsRoundedIcon />
}

const SidebarButton = ({ item, collapsed, onClose, className = 'suite-nav-button suite-nav-button-muted' }) => (
  <Button
    component={item.external ? 'a' : NavLink}
    {...(item.external ? { href: item.path, target: '_blank', rel: 'noopener noreferrer' } : { to: item.path, end: item.path === '/' })}
    onClick={onClose}
    startIcon={item.icon}
    className={className}
    title={collapsed ? item.label : undefined}
    aria-label={item.label}
  >
    <span className="suite-nav-label">{item.label}</span>
  </Button>
)

const SidebarContent = ({ usuario, onClose, collapsed }) => {
  const { canRead, canWrite } = getQualityCapabilities(usuario)
  const applicationItems = getSidebarApplications(usuario)
  const qualityItems = [
    ...(canRead && canWrite ? [{ label: 'Control de calidad', icon: <FactoryRoundedIcon />, path: '/' }] : []),
    ...(canRead ? [{ label: 'Historial de partes', icon: <HistoryRoundedIcon />, path: '/historial' }] : []),
  ]

  return (
    <Box className="suite-sidebar-content">
      <Box className="suite-brand">
        <img className="suite-brand-logo" src={LogoSuite} alt={APP_DATA.appName} />
      </Box>

      <Box className="suite-sidebar-section">
        <SidebarButton
          item={{ label: 'Inicio', icon: <DashboardRoundedIcon />, path: getSuiteUrl(usuario), external: true }}
          collapsed={collapsed}
          onClose={onClose}
          className="suite-nav-button"
        />
      </Box>

      {qualityItems.length > 0 && <Box className="suite-sidebar-section">
        {qualityItems.map((item) => (
          <SidebarButton key={item.path} item={item} collapsed={collapsed} onClose={onClose} />
        ))}
      </Box>}

      {applicationItems.length > 0 && <Box className="suite-sidebar-section">
        <Typography className="suite-sidebar-label">Aplicaciones</Typography>
        {applicationItems.map((item) => (
          <SidebarButton key={item.code} item={{ ...item, icon: getApplicationIcon(item) }} collapsed={collapsed} onClose={onClose} />
        ))}
      </Box>}

      <Box className="suite-sidebar-footer">
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', mb: 2 }} />
        <Typography className="suite-footer-copy">(c) 2026 {APP_DATA.appName}</Typography>
        <Typography className="suite-footer-version">Version {APP_DATA.version}</Typography>
      </Box>
    </Box>
  )
}

export const Sidebar = ({ open, mobile, collapsed, onClose, session }) => {
  if (mobile) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          '& .MuiDrawer-paper': {
            width: 'min(88vw, 256px)',
            background:
              'linear-gradient(180deg, rgba(255, 121, 0, 0.06), rgba(255, 121, 0, 0) 38%), #071017',
            color: '#ffffff',
            borderRight: '1px solid rgba(255, 255, 255, 0.08)',
            overflow: 'hidden',
          },
        }}
        slotProps={{ paper: { className: 'suite-sidebar-drawer' } }}
      >
        <Box className="suite-sidebar suite-sidebar-mobile">
          <SidebarContent
            usuario={session}
            onClose={onClose}
            collapsed={false}
          />
        </Box>
      </Drawer>
    )
  }

  return (
    <Box component="aside" className={`suite-sidebar${collapsed ? ' suite-sidebar-collapsed' : ''}`}>
      <SidebarContent
        usuario={session}
        onClose={onClose}
        collapsed={collapsed}
      />
    </Box>
  )
}
